/* blnc-accordion.js — smooth chevron rotation on open */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.blnc-faq-accordion__item').forEach(function(item) {
    item.addEventListener('toggle', function() {
      item.classList.toggle('is-open', item.open);
    });
  });
});
